import React, { useEffect } from "react";
import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link, useNavigate, useParams } from "react-router-dom";

import { useAppApi } from "@/App";
import { RenderForm } from "@components/Forms/Render";
import { DefaultLayout } from "@components/Layouts";
import { url_reverse } from "@components/Utils";

export default function BlockSettingsScreen() {
    const { t } = useTranslation();
    const { slug, selection_id, block_id, id } = useParams();
    const apiUrl = id
        ? url_reverse("api:landing:block:settings:item", { selection_id, block_id, id })
        : url_reverse("api:landing:block:settings", { selection_id, block_id });
    const { apiData, setApiData } = useAppApi(apiUrl);
    const navigate = useNavigate();

    useEffect(() => {
        if (apiData) {
            const newApiData = { ...apiData };
            newApiData.forms_data.main.data.block_id = block_id;
            setApiData(newApiData);
        }
    }, [apiData?.forms_data]);

    if (!apiData) return;
    const header = (
        <>
            <Link to={url_reverse("admin:event:landing_block:games", { slug, selection_id, block_id })}>
                {t("Игры блока")}
            </Link>
            <span> – </span>
            {t("Настройки блока")}
        </>
    );

    return (
        <DefaultLayout>
            <Card>
                <Card.Header>{header}</Card.Header>
                <Card.Body>
                    <RenderForm
                        prefix={"main"}
                        apiData={apiData}
                        setApiData={setApiData}
                        afterRespOK={() =>
                            navigate(url_reverse("admin:event:landing_block:games", { slug, selection_id, block_id }))
                        }
                    />
                </Card.Body>
            </Card>
        </DefaultLayout>
    );
}
